import type { ISupplierService } from './ISupplierService';
import type { PagedResponse } from '../dto/PagedResponse';
import type { Supplier } from '../dto/Supplier.dto';
import type { CreateSupplierRequest } from '../dto/CreateSupplierRequest';
import type { UpdateSupplierRequest } from '../dto/UpdateSupplierRequest';
import type { ListParams } from '../http/ListParams';
import type { SupplierStatus } from '../types/SupplierStatus.type';
import { QueryBuilder } from '../http/QueryBuilder';
import { JsonRequestBody } from '../http/JsonRequestBody';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { fetchWithAuth } from '../../../utils/fetch/FetchWithAuth';

const BASE = '/api/warehouse/supplier';

export class SupplierService implements ISupplierService {
    async list(params?: ListParams): Promise<PagedResponse<Supplier>> {
        return fetchWithAuth(`${BASE}${QueryBuilder.from(params).build()}`, {
            method: 'GET',
        });
    }

    async get(externalId: string): Promise<Supplier> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'GET',
        });
    }

    async create(payload: CreateSupplierRequest): Promise<Supplier> {
        return fetchWithAuth(BASE, {
            method: 'POST',
            ...JsonRequestBody.from(payload),
        });
    }

    async update(
        externalId: string,
        payload: UpdateSupplierRequest,
    ): Promise<Supplier> {
        return fetchWithAuth(`${BASE}/${externalId}`, {
            method: 'PATCH',
            ...JsonRequestBody.from(payload),
        });
    }

    async updateStatus(
        externalId: string,
        status: SupplierStatus,
    ): Promise<Supplier> {
        return fetchWithAuth(`${BASE}/${externalId}/status`, {
            method: 'PATCH',
            ...JsonRequestBody.from({ status }),
        });
    }
}